import { DEFAULT_MARKETPLACE } from '../../helpers/constants';

const initialState = {
  ui: {
    focusedPricingGroup: null,
    focusedPricingGroupMarketplace: null,
    buttons: {
      createGroupButtonDisabled: true,
    },
  },
  currComparisonSections: [],
  currTNComparisonSections: [],
  stubhubListings: [],
  hashCurrCompSections: {},
  hashCurrTNCompSections: {},
  selectedInventoryRows: [],
  typeListing: DEFAULT_MARKETPLACE,
  selectedGroup: {
    splits: [],
  },
  groupSelected: false,
  staticGraphs: [],
  eventMeta: {},
  eventInfo: {},
  skyboxId: null,
  groupEditingId: -1,
  isGroupContainerLoading: false,
};

const checkAdvanceComparisonsChecks = (previousComps, newComps) => {
  const currentLowRow = previousComps.filter(comp => comp.low_row !== '')?.[0]?.low_row;
  const currentHighRow = previousComps.filter(comp => comp.high_row !== '')?.[0]?.high_row;
  const currentZoneType = previousComps.filter(comp => comp.zone_type !== '')?.[0]?.zone_type;

  if (currentLowRow && currentHighRow) {
    const updatedComps = newComps.map(comp => {
      if (comp.low_row === '' && comp.high_row === '') {
        return {
          ...comp,
          low_row: currentLowRow,
          high_row: currentHighRow,
          zone_type: currentZoneType,
        };
      }
      return comp;
    });
    return updatedComps;
  }
  return newComps;
};

const addComps = (groups, compsArray) => {
  return groups.map(item => ({
    ...item,
    ranks: compsArray.filter(compInfo => compInfo.id === item.id)[0]?.ranks,
    sg_sections: compsArray.filter(compInfo => compInfo.id === item.id)[0]?.sg_sections,
    tnd_sections: compsArray.filter(compInfo => compInfo.id === item.id)[0]?.tnd_sections,
    marketplace: compsArray.filter(compInfo => compInfo.id === item.id)[0]?.marketplace,
  }));
};

const retainUIComps = (state, action) => {
  const mpStateGroups = state.hashCurrTNCompSections[action.marketplace];
  if (mpStateGroups && action.comparison) {
    if (Object.keys(mpStateGroups)?.length > Object.keys(action.comparison)?.length) {
      const stateGroups = Object.keys(mpStateGroups);
      const actionGroups = Object.keys(action.comparison);
      const groupsToRemove = stateGroups.filter(elemento => !actionGroups.includes(elemento));
      const filteredStateGroups = Object.fromEntries(
        Object.entries(mpStateGroups).filter(([key]) => !groupsToRemove.includes(key))
      );
      return filteredStateGroups;
    }
  }
  return action.comparison;
};

const retainCompsFilters = (state, comps, groupId) => {
  if (
    state &&
    state[groupId.toString()] &&
    state[groupId.toString()].filter(comp => comp.high_row !== '' && comp.low_row !== '' && comp.zone_type !== '') &&
    state[groupId.toString()].filter(comp => comp.high_row !== '' && comp.low_row !== '' && comp.zone_type !== '')
      .length > 0
  ) {
    const filteredZones = state[groupId.toString()]
      .filter(comp => comp.high_row !== '' || comp.low_row !== '' || comp.zone_type !== '')
      .map(comp => comp.zone_name);
    const compsToUpdate = comps.filter(comp => comp.high_row === '' || comp.low_row === '' || comp.zone_type === '');
    if (compsToUpdate && compsToUpdate.length > 0) {
      const existingFilters = state[groupId.toString()].filter(
        comp =>
          comp.high_row !== '' && comp.low_row !== '' && comp.zone_type !== '' && filteredZones.includes(comp.zone_name)
      );
      if (existingFilters && existingFilters.length > 0) {
        const zoneName = existingFilters[0].zone_name;
        const highRow = existingFilters[0].high_row;
        const lowRow = existingFilters[0].low_row;
        const zoneType = existingFilters[0].zone_type;
        const readyComps = comps.filter(comp => comp.high_row !== '' || comp.low_row !== '' || comp.zone_type !== '');
        const updatedComps = compsToUpdate.map(comp => {
          return {
            ...comp,
            high_row: comp.zone_name === zoneName ? highRow : comp.high_row,
            low_row: comp.zone_name === zoneName ? lowRow : comp.low_row,
            zone_type: comp.zone_name === zoneName ? zoneType : comp.zone_type,
          };
        });
        const finalComps = readyComps.concat(updatedComps);
        return finalComps;
      }
      return comps;
    }
    return comps;
  }
  return comps;
};

const pricing = (state = initialState, action) => {
  switch (action.type) {
    case 'FOCUS_PRICING_GROUP_SECTION':
      return {
        ...state,
        ui: {
          ...state.ui,
          focusedPricingGroup:
            state.ui.focusedPricingGroup !== action.focusedPricingGroup ? action.focusedPricingGroup : null,
        },
      };
    case 'SET_FOCUS_PRICING_GROUP_MARKETPLACE':
      return { ...state, focusedPricingGroupMarketplace: action.marketplace };
    case 'SET_FORM_TN_COMPARISON_DATA':
      return {
        ...state,
        currTNComparisonSections: checkAdvanceComparisonsChecks(state.currTNComparisonSections, action.comparison),
      };
    case 'SET_TYPE_LISTING':
      return { ...state, typeListing: action.typeListing };
    case 'SET_HASH_COMPARISON_DATA_BULK':
      return {
        ...state,
        hashCurrCompSections: {
          ...state.hashCurrCompSections,
          [action.marketplace]: action.comparison,
        },
      };
    case 'SET_HASH_TN_COMPARISON_DATA_BULK':
      return {
        ...state,
        hashCurrTNCompSections: {
          ...state.hashCurrTNCompSections,
          [action.marketplace]: retainUIComps(state, action),
        },
      };
    case 'SET_HASH_COMPARISON_DATA': {
      return {
        ...state,
        hashCurrCompSections: {
          ...state.hashCurrCompSections,
          [action.marketplace]: {
            ...state.hashCurrCompSections[action.marketplace],
            [action.groupId]: action.comparison,
          },
        },
      };
    }
    case 'SET_HASH_TN_COMPARISON_DATA': {
      return {
        ...state,
        hashCurrTNCompSections: {
          ...state.hashCurrTNCompSections,
          [action.marketplace]: {
            ...state.hashCurrTNCompSections[action.marketplace],
            [action.groupId]: retainCompsFilters(
              state.hashCurrTNCompSections[action.marketplace],
              action.comparison,
              action.groupId
            ),
          },
        },
      };
    }
    case 'CLEAR_HASH_COMPARISON_DATA':
      return {
        ...state,
        hashCurrCompSections: {},
      };
    case 'CLEAR_HASH_TN_COMPARISON_DATA':
      return {
        ...state,
        hashCurrTNCompSections: {},
        currTNComparisonSections: [],
      };
    case 'SET_EVENT_META':
      return { ...state, eventMeta: action.eventMeta };
    case 'SET_EVENT_INFO':
      return { ...state, eventInfo: action.eventInfo };
    case 'SET_SKYBOX_ID':
      return { ...state, skyboxId: action.skyboxId };
    case 'TOGGLE_CREATE_GROUP_BUTTON':
      return { ...state, ui: { ...state.ui, buttons: { createGroupButtonDisabled: action.disabled } } };
    case 'INVENTORY_SELECTED_ROWS':
      return { ...state, selectedInventoryRows: action.selectedInventoryRows };
    case 'SET_GROUP':
      return { ...state, selectedGroup: action.group };
    case 'SET_SPLITS':
      return {
        ...state,
        selectedGroup: {
          ...state.selectedGroup,
          splits: action.splits,
        },
      };
    case 'GROUP_SELECTED':
      return { ...state, groupSelected: action.status };
    case 'SET_EDITING_GROUP':
      return { ...state, groupEditingId: action.groupEditingId };
    case 'SET_IS_GROUP_CONTAINER_LOADING':
      return { ...state, isGroupContainerLoading: action.status };
    case 'SET_FILTERED_STUBHUB_LISTINGS':
      return { ...state, stubhubListings: action.stubhubListings };
    case 'SELECTED_GROUP_RANKS_COMPS':
      // eslint-disable-next-line no-case-declarations
      const updatedGroup = addComps(
        [state.selectedGroup],
        action.payload.filter(group => group.id === state.selectedGroup.id)
      );
      return { ...state, selectedGroup: updatedGroup[0] };
    default:
      return state;
  }
};

export default pricing;
